<template>
  <div class="hero">
    <PanelCompanies
      :page="pageCompanys"
      :length="totalPagesCompanys"
      :companies="companys"
      @onPageChange="changePage"
    />
  </div>
</template>
<script>
import apisCompanys from '@/apis/apisCompanys';

import PanelCompanies from '@/components/PanelCompanies.vue';

export default {
  name: 'CompanysView',
  components: {
    PanelCompanies
  },
  data(){
    return {
      companys: [],
      pageCompanys: 1,
      totalPagesCompanys: 1
    }
  },
  created(){
    // Antes esto esperaba a navigator.geolocation ANTES de pedir las empresas:
    // eran ~4,4 segundos de pantalla vacia (medidos, y con el permiso ya dado),
    // mas una llamada a la API externa de bigdatacloud para traducir las
    // coordenadas a una ciudad.
    //
    // Y todo ese trabajo no cambiaba ni un resultado: la consulta del backend
    // une los filtros con OR y el front manda text vacio, asi que la rama
    // "empresa LIKE '%%'" ya es verdadera para todas las filas y la ciudad
    // nunca se llega a aplicar. Comprobado pidiendo la busqueda con Tabio,
    // con Tokio y sin nada: las mismas 7 empresas en los tres casos.
    //
    // Si algun dia se quiere filtrar por cercania de verdad, hay que arreglar
    // antes la consulta (OR por AND) y decidir que mostrar a alguien cuya
    // ciudad no tenga ninguna empresa registrada.
    this.searchCompanies("", "", "")
  },
  methods: {
    searchCompanies(text,country, city){
      apisCompanys.search(text, country, city, this.pageCompanys - 1)
        .then(companys => {
          this.companys = companys.content
          this.totalPagesCompanys = companys.totalPages
          this.pageCompanys = companys.pageNumber + 1; 
        })
    },
    changePage(page){
      apisCompanys.search("", "", "", page - 1)
        .then(companys => {
          this.companys = companys.content
          this.pageCompanys = companys.pageNumber + 1; 
        })
    }
  }
}
</script>
<style scoped>
/* Aqui habia una copia entera de la grilla (.card-companies y .ComponentCompany)
   que NUNCA se aplico: los estilos scoped de una vista no alcanzan al nieto, y
   la grilla la pinta PanelCompanies. Esta ahi si se quiere ajustar. */
</style>
